<div class="ht-shell" [class.vertical]="orientation === 'vertical'">
  <div class="ht">
    @if (overflowing() && orientation === 'horizontal') {
      <button
        type="button"
        class="ht-arrow"
        [style.paddingRight.px]="6"
        [disabled]="!canScrollLeft()"
        (click)="scroll(-1)"
        aria-label="Scroll tabs left"
      >
        <app-icon name="chevronLeft" [size]="16" />
      </button>
    }

    <div #strip class="ht-strip" (scroll)="onScroll()">
      @for (tab of visibleTabs; track tab.id) {
        <button
          type="button"
          class="ht-tab"
          [class.active]="activeId() === tab.id"
          [disabled]="tab.disabled"
          (click)="select(tab)"
        >
          @if (tab.icon) {
            <app-icon [name]="tab.icon" [size]="14" />
          }
          {{ tab.label }}
          @if (tab.count != null) {
            <span class="ht-count">{{ tab.count }}</span>
          }
        </button>
      }
    </div>

    @if (overflowing() && orientation === 'horizontal') {
      <button
        type="button"
        class="ht-arrow"
        [style.paddingLeft.px]="6"
        [disabled]="!canScrollRight()"
        (click)="scroll(1)"
        aria-label="Scroll tabs right"
      >
        <app-icon name="chevronRight" [size]="16" />
      </button>
    }
  </div>

  <div class="tab-content">
    @if (activeTemplate(); as tpl) {
      @if (lazy) {
        <ng-container [ngTemplateOutlet]="tpl"></ng-container>
      } @else {
        @for (panel of tabContents(); track panel.tabId) {
          <div class="ht-panel" [hidden]="panel.tabId !== activeId()">
            <ng-container [ngTemplateOutlet]="panel.template"></ng-container>
          </div>
        }
      }
    } @else {
      <ng-content></ng-content>
    }
  </div>
</div>
